import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { ProjectProvider } from "./contexts/ProjectContext";
import SaveToProjectModal from "./components/SaveToProjectModal";

function App() {
  return (
    <AuthProvider>
      <ProjectProvider>
        <Routes />
        <SaveToProjectModal />
      </ProjectProvider>
    </AuthProvider>
  );
}

export default App;
